/**
 * Just map to-string over args. Create a query key for useQuery() from any number of arguments.
 * @param  {...any} args
 * @returns {string[]}
 */
export function queryKey(...args) {
  return args.map((arg) => str(arg));
}

/**
 * stringify / tostring anything
 * @param {any} arg
 * @returns {string}
 */
function str(arg) {
  try {
    return JSON.stringify(arg);
  } catch (e) {
    return "" + arg;
  }
}

/**
 * See: urlParamsString()
 * @param {string|number|boolean|Array} value
 * @returns {string} url-encoded string
 */
export function urlEncode(value) {
  if (value instanceof Array) {
    return value.map(urlEncode).join(",");
  }
  let urlPart = encodeURIComponent(value);
  // also convert 's which can cause problems
  urlPart = urlPart.replace(/'/g, "%27");
  return urlPart;
}
